// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"bdca83d0","9214":"8cd67d79","55529":"9638a4e4","75077":"9638a4e4","84747":"1aee91e3","96387":"9638a4e4","96609":"d274bb90"}[chunkId] + ".chunk.css";
};